import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Ökologische Moortypen</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<h6>Klassifikation nach Succow/Joosten</h6>
			<div class="table-responsive">
				<table class="table table-sm table-bordered moortyp-table">
					<thead>
						<tr>
							<th rowspan="2">Abk.</th>
							<th rowspan="2">Bezeichnung</th>
							<th rowspan="2">Nc %</th>
							<th rowspan="2">C/N</th>
							<th rowspan="2">pH (KCl)</th>
							<th rowspan="2">V-Wert</th>
							<th colspan="4">VN-Stufen (SEA 95)</th>
							<th colspan="4">Nährkraftstufen (SEA 95)</th>
						</tr>
						<tr>
							<th *ngFor="let i of [1,2,3,4]">{{ i }}</th>
							<th *ngFor="let i of [1,2,3,4]">{{ i }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of rows" [class.group-start]="row.groupStart">
							<td *ngIf="row.abkRowspan" [attr.rowspan]="row.abkRowspan" class="abk-cell"><strong>{{ row.abk }}</strong></td>
							<td *ngIf="row.bezRowspan" [attr.rowspan]="row.bezRowspan">{{ row.bez }}</td>
							<td *ngIf="row.paramRowspan" [attr.rowspan]="row.paramRowspan" class="param-cell">{{ row.nc }}</td>
							<td *ngIf="row.paramRowspan" [attr.rowspan]="row.paramRowspan" class="param-cell">{{ row.cn }}</td>
							<td *ngIf="row.paramRowspan" [attr.rowspan]="row.paramRowspan" class="param-cell">{{ row.ph }}</td>
							<td *ngIf="row.paramRowspan" [attr.rowspan]="row.paramRowspan" class="param-cell">{{ row.vwert }}</td>
							<td *ngFor="let vn of row.vnStufen" class="vn-cell">{{ vn }}</td>
							<td *ngFor="let nk of row.naehrkraft" class="nk-cell">{{ nk }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<p class="text-muted small mt-2 mb-0">Quelle: SEA TeilA, Darst. A 2-5, S. 93 (nach Succow/Joosten)</p>
		</div>
	`,
	styles: [`
		.moortyp-table {
			font-size: 0.8rem;
			min-width: 750px;
		}
		.moortyp-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
			white-space: nowrap;
		}
		.moortyp-table td {
			vertical-align: middle;
		}
		.abk-cell {
			text-align: center;
			vertical-align: middle;
		}
		.param-cell {
			text-align: center;
			white-space: nowrap;
			vertical-align: middle;
		}
		.vn-cell, .nk-cell {
			text-align: center;
			font-size: 0.75rem;
			white-space: nowrap;
		}
		.group-start td {
			border-top: 2px solid #adb5bd;
		}
		h6 {
			font-weight: 600;
		}
	`]
})
export class OekologischerMoortypInfoModalComponent {
	activeModal = inject(NgbActiveModal);

	rows = [
		{ abk: 'SA', abkRowspan: 1, bez: 'Sauer-Armmoor', bezRowspan: 1, nc: '2,0 – 3,0', cn: '> 33', ph: '2,0 – 4,8', vwert: '< 46', paramRowspan: 1, vnStufen: ['N3B4', 'N3B5', 'N3B6', '–'], naehrkraft: ['D/A', 'D/A', 'D/A', '–'], groupStart: true },
		{ abk: 'SZ', abkRowspan: 3, bez: 'Sauer-Zwischenmoor', bezRowspan: 3, nc: '3,0 – 4,9', cn: '20 – 33', ph: '2,0 – 4,8', vwert: '< 46', paramRowspan: 3, vnStufen: ['N3B4', 'N3B5', 'N3B6', '–'], naehrkraft: ['A', 'A', 'A', '–'], groupStart: true },
		{ vnStufen: ['N4B4', 'N4B5', 'N4B6', '–'], naehrkraft: ['Z', 'Z', 'Z', '–'] },
		{ vnStufen: ['N5B4', 'N5B5', 'N5B6', '–'], naehrkraft: ['M', 'M', 'M', '–'] },
		{ abk: 'BZ', abkRowspan: 1, bez: 'Basen-Zwischenmoor', bezRowspan: 1, nc: '3,0 – 4,9', cn: '20 – 33', ph: '4,8 – 6,4', vwert: '46 – 70', paramRowspan: 1, vnStufen: ['N3B7', 'N4B7', 'N5B7', '–'], naehrkraft: ['M', 'M', 'M', '–'], groupStart: true },
		{ abk: 'KZ', abkRowspan: 1, bez: 'Kalk-Zwischenmoor', bezRowspan: 1, nc: '3,0 – 4,9', cn: '20 – 33', ph: '6,4 – 8,0', vwert: '> 70', paramRowspan: 1, vnStufen: ['N3B8', 'N4B8', 'N5B8', '–'], naehrkraft: ['AC', 'ZC', 'MC', '–'], groupStart: true },
		{ abk: 'RM', abkRowspan: 3, bez: 'Reichmoor', bezRowspan: 3, nc: '> 4,9', cn: '< 20', ph: '> 3,5', vwert: '–', paramRowspan: 3, vnStufen: ['N5B5', 'N5B6', 'N5B7', 'N5B8'], naehrkraft: ['M', 'M', 'M', 'MC'], groupStart: true },
		{ vnStufen: ['N6B5', 'N6B6', 'N6B7', 'N6B8'], naehrkraft: ['K', 'K', 'K', 'KC'] },
		{ vnStufen: ['N7B5', 'N7B6', 'N7B7', 'N7B8'], naehrkraft: ['R', 'R', 'R', 'RC'] },
	];

}
